export default {
  userAccessFor: 'Acceso de usuario para:',
  save: 'Guardar',
  search: 'Buscar',
  name: 'Nombre',
  lastname: 'Apellido',
  email: 'Correo electrónico'
}
